<template>
  <v-layout row wrap>
    <v-flex xs12 md8 v-if="!getProfileHaveClient">
      <v-card>
        <v-card-title>
          <span class="headline">Юридический ассистент служба автоматизации рутиных юридических оппераций.</span>
        </v-card-title>
        <v-card-text>
          Для использования Юридического ассистента, необходимо определить Юридическое лицо которое Вы представляете.
          Регистрируйтесь и направляйте запросы для подготовки Юридических документов: претензий ...
        </v-card-text>
        <v-card-actions>
          <v-btn to="/register">Регистрация</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
    <v-flex xs12 md8 v-if="getProfileHaveClient && !$route.params.matterId">
      <v-assist-set></v-assist-set>
    </v-flex>
    <v-flex xs12 md8 v-if="getProfileHaveClient && $route.params.matterId">
      <v-assist-page :itemId="$route.params.matterId"></v-assist-page>      
    </v-flex>   
  </v-layout>
</template>

<script>
  import { mapGetters } from 'vuex'
  import vAssistSet from './AssistSet.vue'
  import vAssistPage from './AssistPage.vue'

  export default {
    name: 'assist-panel',
    components: {vAssistSet, vAssistPage},
    props: {
    },
    data: () => ({
      tagIds: []
    }),
    created () {
    },
    mounted () {
    },
    watch: {
    // в случае изменения маршрута запрашиваем данные вновь
    },
    computed: {
      ...mapGetters({
        getProfileHaveClient: 'getProfileHaveClient'
      })
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// AssistPanel.vue?150137f7